// extracted by mini-css-extract-plugin
module.exports = {"recentlySold":"RecentlySold_recentlySold__IRgE0","titleRegion":"RecentlySold_titleRegion__2vEF8","title":"RecentlySold_title__3oviU"};